import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import { Component, Prop } from 'vue-property-decorator';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import SectorTable from '@sectors/components/tables/sector-table/sector-table.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { Resource } from '@centers/interfaces/resource';
import ResourceOnlineBookingConfigForm from '@centers/components/forms/resource-online-booking-config-form.vue';
import { ResourceOnlineBookingConfig } from '@centers/interfaces/online-booking-config';

@Component({
  name: 'bpc-resource-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-sector-table': SectorTable,
    'bpc-drawer-modal': DrawerModal,
    'bpc-resource-online-booking-config-form': ResourceOnlineBookingConfigForm,
  },
})
export default class ResourceTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    onlineBookingConfigForm: InstanceType<typeof ResourceOnlineBookingConfigForm> & {
      manageSaveErrors(errors: any): void;
    };
  };
  public entity: Resource = null;
  public entityName = 'resource';
  public pluralEntityName = 'resources';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {
    settings: {
      activated: false,
      type: 'action',
      icon: 'cog',
      variant: 'secondary',
      text: null,
      show: true,
      event: 'settings',
      selectElements: false,
      tag: 'right',
    },
  };
  public customRowActions = {
    details: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'details',
    },
  };

  public showOnlineBookingConfigForm = false;
  public onlineBookingConfig: ResourceOnlineBookingConfig = null;

  constructor() {
    super();
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Resource;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(newEntity, 'type', this.entity.type);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  get selectedDisciplinesForOnlineBookingIds() {
    return this.entity?.disciplinesForOnlineBooking?.map(discipline => discipline.id) || [];
  }

  /**
   * Overwrite method of abstract-table to add events for custom page actions.
   * @param $event
   */
  customOnPageAction($event: string) {
    switch ($event) {
      case 'settings':
        this.onResourceSetting();
        break;
    }
    console.log('Page Title event >>> ' + $event);
  }

  customOnRowAction($event: { event: string; item: any }) {
    const actionName = $event.event === 'public-details' ? 'publicDetails' : $event.event;
    if ($event.item.item.actions[actionName].activated) {
      switch ($event.event) {
        case 'details':
          this.$router.push({
            name: 'public-resource-details',
            params: { alias: $event.item.item.alias },
          });
          break;
      }
    }
  }

  onResourceSetting() {
    // this.crudEntitySetting = entity;
    this.showSettingForm = true;
    this.showDrawerSettingSection = true;
  }

  onSettingFormClose() {
    this.showSettingForm = false;
    this.showDrawerSettingSection = false;
  }

  onShow(e) {
    this.onEdit(e);
  }

  actionBeforeSaveForm(formModel) {
    delete formModel.optionGroup;
    formModel.onlineBookingConfig = this.onlineBookingConfig;
    return formModel;
  }
  onModelLoaded(formModel: Resource) {
    this.onlineBookingConfig =
      formModel?.optionGroup?.options?.booking || this.getDefaultResourceOnlineBookingConfig();
    this.showOnlineBookingConfigForm = true;
  }
  onValidationErrorsChanged(errorsObject) {
    console.log('onValidationErrorsChanged', errorsObject);
    const onlineBookingConfigErrors = Object.keys(errorsObject).reduce((output, key) => {
      if (key.startsWith('onlineBookingConfig.')) {
        const newKey = key.replace('onlineBookingConfig.', '');
        output[newKey] = errorsObject[key];
      }
      return output;
    }, {} as { [key: string]: any });
    this.$refs.onlineBookingConfigForm.manageSaveErrors(onlineBookingConfigErrors);
  }
  getDefaultResourceOnlineBookingConfig(): ResourceOnlineBookingConfig {
    return {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      min_time_before_player_slot_cancellation: '48',
      membership_required: false,
      memberships_allow_booking: [],
      start_time: '08:00',
      step_duration: 60,
      only_with_subscriptions: 'subscription_only',
      defaultValueSwitchModel: {
        allowed_durations: true,
        max_time_before_booking: true,
        min_time_before_booking: true,
        allow_cancel_booking_event: true,
        min_time_before_cancellation: true,
        min_time_before_player_slot_cancellation: true,
        membership_required: true,
        memberships_allow_booking: true,
        start_time: true,
        step_duration: true,
        only_with_subscriptions: true,
      },
    };
  }

  /* Lifecycle hooks */

  // created() { }
  mounted() {
    this.showOnlineBookingConfigForm = false;
  }
  // updated () { }
  // destroyed () { }
}
